import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SliderModule } from '@nimbus-library/features/shared/components/slider/slider.module';
import { RangeSliderComponent } from '@nimbus-library/features/shared/components/range-slider/range-slider.component';
import { SkillLevelSelectorComponent } from '@nimbus-library/features/shared/components/material/input-assign-skill/skill-stepper/skill-level-selector.component';

@NgModule({
  imports: [CommonModule, SliderModule, RangeSliderComponent],
  exports: [SkillLevelSelectorComponent],
  declarations: [SkillLevelSelectorComponent],
})
export class SkillStepperModule {}
